import LocationListView from './LocationListView'
import React from 'react'
import useLocationList from './useLocationList'

const LocationList = (): JSX.Element => {
  const state = useLocationList()
  return <LocationListView {...state} />
}
export default LocationList
